const API = {
  LOGIN: "/web/login",
  CHANGE_PASS: "/web/v3/user/resetPassword",
};

export default API;
